import CommonBase from '../../settings/util/commonBase'

class CarrierBaseController extends CommonBase {
   /*@ngInject*/
  constructor(Auth, $state, User, Service, Modal, $translate, $stateParams) {

    super(Auth, $state, User, Service, Modal, $translate, $stateParams)

    this.errors = {}
    this.loading = false
    this.errorMessage = ''
    this.model = {}
    this.id = 'carrier'
  }
  reset() {
    this.model = angular.copy(this.defaultModel)
    this.clearErrors()
  }
  askCreate() {
    this.Modal.confirm({
      header: this.$translate.instant(this.id + '.create_another_title'),
      message: this.$translate.instant(this.id + '.create_another_message'),
      callback: ({
        modal,
        $scope
      }) => {
        this.reset()
        modal.close()
      },
      negative: ({
        modal,
        $scope
      }) => {
        modal.close()
        window.history.go(-1)
      },
      type: 'primary',
      buttons: ['common.yes', 'common.no']
    })
  }

  validate() {
    this.clearErrors()
    for (let key in this.model) {
      if (!this.model[key]&&typeof(this.model[key])=='string') {
        this.addError(key, key.charAt(0).toUpperCase() + key.slice(1) + ' is mandatory')
      }
    }

    return Object.keys(this.errors).length <= 0
  }

  clearErrors() {
    this.errors = {}
    this.errorMessage = ''
  }

  addError(id, message) {
    this.errors[id] = message
  }
}

export default CarrierBaseController;


// WEBPACK FOOTER //
// ./client/app/components/carrier/common/carrier.base.controller.js